










































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SectionTuileNav from '@/components/shared/SectionTuileNav.vue'
import PiscineListItem from '@/components/piscines/PiscineListItem.vue'

import { ITuileNav } from '@/models/ui/ITuileNav'
//@ts-ignore
import L from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LPolygon } from 'vue2-leaflet'
import { latLng } from "leaflet"
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { getDefaultAloMedia } from '@/models/alo/AloMedia'
import { getImageUrl } from '@/utils/images'
import {zoneDomicile} from '@/models/ZoneDomicile'

@Component({
  name:'Piscines',
  props:{
    activityId:{
      type:Number,
      default: -1
    }
  },
  components: { 
    SectionTuileNav,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPolygon,
    LIcon,
    PiscineListItem
  },
})
export default class Piscines extends Vue {
  
  private activityId!:number
  private acyId = -1
  private zoom = 10
  //private path = "/images/"
  private center = [43.143089, 6.024514]
  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  private attribution ='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  private marker = latLng(43.143089, 6.024514)
  private isIntersecting = false
  private showFilterActivite = false  
  private hoverPiscine = getDefaultAloPiscine()

  mounted(){
    this.acyId = this.activityId  
  }

  @Watch('activityId')
  onActivityIdChanged(newValue:number) {
    this.acyId = newValue
  }

  get zoneDomicile() {
    return zoneDomicile
  }

  get hoverImage(){
    return getImageUrl(getDefaultAloMedia(),30)
  }

  get getImageUrl(){
    return getImageUrl
  }
  
  get latLng(){
    return latLng
  }

  get piscineList(){
    return this.$store.myGetters.piscineList.filter(p => p.psnEnable && (this.acyId == -1 || p.acyIds.indexOf(this.acyId)>-1))
    //return [...this.$store.myGetters.piscineList.filter(p => p.psnEnable && (this.acyId == -1 || p.acyIds.indexOf(this.acyId)>-1)),this.piscineChezVous]
  }


  created(){
    this.$store.myActions.ADM_PISCINE_ENSURE()
    this.$store.myActions.ADM_ACTIVITY_ENSURE()    
  }

  selectActivite(activityId:number) {
    this.acyId = activityId
    this.showFilterActivite = false
  }

  setHoverPiscine(piscine:AloPiscine = getDefaultAloPiscine()) {      
    this.hoverPiscine = piscine     
  }

  centerOn(piscine:AloPiscine) {    
    this.center = [piscine?.address?.gpsLat??43.143089,piscine?.address?.gpsLon??6.024514]    
  }

  get selectedActivite(){
    return this.$store.myGetters.activityDic[this.acyId]?.libelle ?? "Toutes"
  }

  get activityList(){
    return this.$store.myGetters.activityList
  }  

  get piscineChezVous(){
    return {
      libelle:"A votre domicile",
      address:{
        libelle:"CHEZ VOUS"
      },
      acyIds:this.activityList.map(a=>a.id),
      image:getDefaultAloMedia()
    } as AloPiscine
  }
}
